<template>
  <div class="header">
    <div class="container-fluid">
      <!-- Hearer  -->
      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item fw-bolder">IAM Client</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <!-- Card  -->
      <div class="card">
        <div class="card-body mt-3 mb-3">
          <!-- <div class="row" style="margin-left: 15px; margin-right: 15px">
            <div class="col-12 col-lg-3"></div>
            <div class="col">
              <div class="form-group d-flex float-end">
                <b-button v-b-modal.modal-1 variant="primary">
                  <span class="fe fe-plus-circle"></span>
                  Create
                </b-button>
              </div>
            </div>
          </div> -->

          <!-- {{ getListClient }} -->
          <div>
            <vue-good-table
              :line-numbers="true"
              :columns="column"
              :rows="getListClient"
              :sort-options="{
                enabled: false
              }"
              :search-options="{
                enabled: true
              }"
              :total-rows="getListClient.length"
              :pagination-options="{
                enabled: true,
                mode: 'pages',
                position: 'bottom',
                perPage: 10,
                perPageDropdown: [10, 50, 100],
                dropdownAllowAll: false,
                setCurrentPage: 1,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Rows per page',
                ofLabel: 'of',
                pageLabel: 'page',
                allLabel: 'All'
              }"
              style-class="vgt-table border-0 table">
              <!-- Loading -->
              <div slot="emptystate" class="text-center font-size-14">
                No data available
              </div>
              <!-- Custom Rows -->
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'">
                  <b-button
                    class="no-wrap btn-pill"
                    variant="info"
                    title="View Detail"
                    size="sm"
                    @click="viewDetail(props.row)">
                    <span class="fe fe-eye"></span>
                  </b-button>
              
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-1" size="lg" hide-footer title="Add Client Role">
      <form @submit.prevent="addClientRoles()">
        <div class="row g-3">
          <div class="form-group col">
            <label>Client Role Name<span class="text-danger">*</span></label>
            <input
              type="text"
              v-model="bodyAdd.roleName"
              class="form-control"
              placeholder="Client Role Name"
              v-validate="'required'"
              name="Client Role Name" />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Client Role Name')"
              >{{ errors.first("Cliient Role Name") }}</span
            >
          </div>
        </div>

        <div class="form-group">
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="submit"
            v-if="isLoading == false">
            Save
          </button>
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
            v-else>
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"></span>
            Loading...
          </button>
          <button
            type="button"
            style="margin-right: auto; float: right"
            class="mt-4 btn btn-outline-primary mr-3"
            @click="$bvModal.hide('modal-1')">
            Cancel
          </button>
        </div>
      </form>
    </b-modal>
    <b-modal id="modal-2" size="xl" hide-footer title="Detail Client">
      <div class="row">
        <div class="col">
          <div class="form-group d-flex float-end mb-3">
            <b-button v-b-modal.modal-1 variant="primary">
              <span class="fe fe-plus-circle"></span>
              Create Client Role
            </b-button>
          </div>
        </div>
      </div>

      <vue-good-table
        :line-numbers="true"
        :columns="columnClientRole"
        :rows="clientRole"
        :sort-options="{
          enabled: false
        }"
        :search-options="{
          enabled: true
        }"
        :total-rows="clientRole.length"
        :pagination-options="{
          enabled: true,
          mode: 'pages',
          position: 'bottom',
          perPage: 10,
          perPageDropdown: [10, 50, 100],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'next',
          prevLabel: 'prev',
          rowsPerPageLabel: 'Rows per page',
          ofLabel: 'of',
          pageLabel: 'page',
          allLabel: 'All'
        }"
        style-class="vgt-table border-0 table">
        <!-- Loading -->
        <div slot="emptystate" class="text-center font-size-14">
          No data available
        </div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'actions'">
            <b-button
              class="no-wrap ml-2"
              variant="danger"
              style="margin-left: 5px"
              size="sm"
              @click="deleteRole(props.row.name)">
              <span class="fe fe-trash-2"></span>
            </b-button>
          </span>
        </template>
      </vue-good-table>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "Rolemanagement",
  computed: {
    getListClient() {
      return this.$store.getters["role_management/client"];
    }
   
  },
  data() {
    return {
      listSite: [],
      fullname: "",
      isAdd: true,
      isRole: false,
      loadRole: false,
      isLoading: false,
      
      bodyAdd: {
          clientId: "",
        roleName:"",
        name: "",
        site_name: "",
        site_link: "",
        selectDepartment: []
      },
     
      clientRole: [],
      columnClientRole: [
        // {
        //   label: "ID",
        //   field: "id",
        //   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
        //   tdClass: "no-wrap color-secondary align-middle"
        // },
        {
          label: "Role Name",
          field: "name",
          thClass: "table-header no-wrap w-90 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        },
        {
          label: "Actions",
          field: "actions",
          thClass:
            "table-header no-wrap w-10 text-muted font-weight-bold text-center",
          tdClass: "no-wrap color-secondary align-middle text-center",
          sortable: false
        }
      ],
      column: [
        {
          label: "Client Key",
          field: "client_key",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        },
        {
          label: "Client ID",
          field: "client_id",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        },
        // {
        //   label: "Name",
        //   field: "name",
        //   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
        //   tdClass: "no-wrap color-secondary align-middle"
        // },
        // {
        //   label: "Description",
        //   field: "description",
        //   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
        //   tdClass: "no-wrap color-secondary align-middle"
        // },
        {
          label: "Actions",
          field: "actions",
          thClass:
            "table-header no-wrap w-40 text-muted font-weight-bold text-center",
          tdClass: "no-wrap color-secondary align-middle text-center",
          sortable: false
        }
      ]
    };
  },

  mounted() {
    this.getClient();
   
  },
  methods: {
    getClient() {
      this.$store
        .dispatch("role_management/getClient")
        .then((response) => {
          let data = this.$store.getters["role_management/client"];
          // this.listSite = data.data.rows;
        //   console.log(data);
        })
        .catch((error) => {
          console.error("Error fetching variables:", error);
        });
    },
 
   
    addClientRoles() {
      this.$validator.validateAll().then(async (res) => {
        if (!res) return false;
        this.isLoading = true;
        try {
            let body = {
            // clientId: this.bodyAdd.clientId,
            name: this.bodyAdd.roleName,
            };
          this.$store
            .dispatch("role_management/createClientRole",  {
            clientId: this.bodyAdd.clientId,
            roleData: body
          })
            .then((resp) => {
              this.$swal("Created", "Create role success", "success").then(() => {
                  this.bodyAdd = {
                    clientId: this.bodyAdd.clientId,
                 roleName:""
                  };
                this.$store
        .dispatch("role_management/getClientRoles", this.bodyAdd.clientId) .then((resp) => {
          let data = this.$store.getters["role_management/client_roles"];
          this.clientRole = data;
        //   this.bodyAdd.clientId = props.id;
        //   console.log("datadetail=>>", data);
        });
                this.isLoading = false;
                this.$bvModal.hide("modal-1");
              });
            });
        } catch (error) {
          this.isLoading = false;
          this.$swal("Error", "Error while create data", "error");
        }
      });
    },

    viewDetail(props) {
      this.$store
        .dispatch("role_management/getClientRoles", props.client_key)
        .then((resp) => {
          let data = this.$store.getters["role_management/client_roles"];
          this.clientRole = data;
          this.bodyAdd.clientId = props.client_key;
        });
      this.$bvModal.show("modal-2");
    },
   

    deleteRole(name) {
        // console.log("hapus hapus",name)
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("role_management/deleteClientRole",  {
          clientId: this.bodyAdd.clientId,
          roleName: name
        })
            .then((resp) => {
                this.$swal("Deleted!", "Client Role has been deleted.", "success");
               this.$store
        .dispatch("role_management/getClientRoles", this.bodyAdd.clientId) .then((resp) => {
          let data = this.$store.getters["role_management/client_roles"];
          this.clientRole = data;
       
        });
            })
            .catch((resp) => {
              this.$swal("Error", "Error while delete data", "error");
            });
        }
      });
    }
  }
};
</script>
